export const maintenanceScreenWeb = 'core-maintenance-screen-login-web'
export const trustThisDeviceWeb = 'core-trust-this-device-web'
export const signInWithAppleWeb = 'core-sign-in-with-apple-web'
export const emailRedesignWeb = 'growth-email-redesign-web'
